<script setup lang="ts">
const props = defineProps<{
  latitude: number
  longitude: number
  name: string
}>()

const mapUrl = computed(() => {
  const lat = props.latitude
  const lng = props.longitude
  return `https://www.openstreetmap.org/export/embed.html?bbox=${lng - 0.01},${lat - 0.008},${lng + 0.01},${lat + 0.008}&layer=mapnik&marker=${lat},${lng}`
})
</script>

<template>
  <div class="aspect-[4/3] w-full rounded-lg overflow-hidden border border-default bg-muted">
    <ClientOnly>
      <iframe
        :src="mapUrl"
        class="w-full h-full"
        frameborder="0"
        scrolling="no"
        :title="`Mapa - ${name}`"
        loading="lazy"
      />
      <template #fallback>
        <div class="w-full h-full flex items-center justify-center text-dimmed">
          <UIcon name="i-lucide-map" class="w-8 h-8" />
        </div>
      </template>
    </ClientOnly>
  </div>
</template>
